import { render, staticRenderFns } from "./personhome.vue?vue&type=template&id=61ae700a&scoped=true&"
import script from "./personhome.vue?vue&type=script&lang=js&"
export * from "./personhome.vue?vue&type=script&lang=js&"
import style0 from "./personhome.vue?vue&type=style&index=0&id=61ae700a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ae700a",
  null
  
)

export default component.exports